import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { LOAD_ANALYTIC } from './constants';
import {
  AnalyticDataActionTypes,
  AnalyticError,
  AnalyticSuccess,
  IAnalyticState,
} from './types';
import { AnalyticResultItemEnum } from 'src/utils/enum';

const initialState: IAnalyticState = {
  status: idle,
  data: {
    name: '',
    type: 0,
    resultTable: [],
    summaryTable: [],
  },
  error: null,
};

export default produce(
  (draft = initialState, action: AnalyticDataActionTypes): IAnalyticState => {
    switch (action.type) {
      case LOAD_ANALYTIC + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case LOAD_ANALYTIC + SUCCESS: {
        draft.status = fulfilled;
        const res = (action as AnalyticSuccess).payload;
        draft.data.name = res.results.name;
        draft.data.type = res.results.type;
        draft.data.resultTable = res.results.items.map((item) => ({
          number: item[AnalyticResultItemEnum.NUMBER]?.value,
          points: item[AnalyticResultItemEnum.POINTS]?.value,
          passingScore: item[AnalyticResultItemEnum.POINTS]?.passing_score,
          date: item[AnalyticResultItemEnum.DATE]?.value,
          questions: item.slice(3).map((answer) => ({
            is_required: answer?.is_required,
            comment: answer?.comment,
            title: answer?.title,
            type: answer?.type,
            rating: answer?.rating,
            question: answer?.title,
            answer: answer?.values, // ответы пользователя
            answers: answer?.answers, // варианты ответа, которые есть
          })), // первые три объекта массива - доп информация
        }));
        draft.data.summaryTable = res.summary_table;
        break;
      }
      case LOAD_ANALYTIC + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AnalyticError).error;
        break;
      }
      case LOAD_ANALYTIC + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
